// extracted by extract-css-chunks-webpack-plugin
module.exports = {"deleteButton":"DeleteItemButton__deleteButton___15qx0","linkOption":"DeleteItemButton__linkOption___1S83v","confirmMessage":"DeleteItemButton__confirmMessage___2qGDY","buttonWrapper":"DeleteItemButton__buttonWrapper___1Wlwo"};
    if(module.hot) {
      // 1778083496284
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  